import React from 'react';

import { ExternalNavigationService } from './external-navigation-service';

interface ContextValue
  extends Readonly<{
    getServiceInstance: () => ExternalNavigationService;
  }> {}

const Context = React.createContext<ContextValue>({
  getServiceInstance: () => {
    throw new Error('ExternalNavigationContextProvider not found!');
  },
});

interface ExternalNavigationContextProviderProps
  extends Readonly<{
    service: ExternalNavigationService;
    children?: React.ReactNode;
  }> {}

export const ExternalNavigationContextProvider = React.memo<ExternalNavigationContextProviderProps>((props) => {
  const { service, children } = props;

  const getServiceInstanceCallback = React.useCallback(() => service, [service]);

  const ContextValue = React.useMemo(() => {
    const contextValue: ContextValue = {
      getServiceInstance: getServiceInstanceCallback,
    };

    return contextValue;
  }, [getServiceInstanceCallback]);

  return <Context.Provider value={ContextValue}>{children}</Context.Provider>;
});

export const useExternalNavigationContext = () => React.useContext<ContextValue>(Context);
